module.exports = __webpack_public_path__ + "img/chevron-derecho-1.49edb45f.svg";